import React, { useState } from 'react';
import { ReactComponent as FilterIcon } from '../svg/filter.svg';
import { ReactComponent as SortIcon1 } from '../svg/sort-1.svg';
import { ReactComponent as SortIcon2 } from '../svg/sort-2.svg';
import FilterModal from './FilterModal'; // 导入FilterModal组件
import '../css/FilterSortBar.css'; // 引入样式文件

const FilterSortBar = ({ onSortChange }) => {
  const [sortAsc, setSortAsc] = useState(true); // 初始排序方式为正序
  const [selectedOption, setSelectedOption] = useState('signal_strength'); // 默认选中的排序选项为信号强度
  const [showFilterModal, setShowFilterModal] = useState(false); // 控制FilterModal的显示与隐藏

  const handleSortClick = () => {
    setSortAsc(!sortAsc); // 切换排序方式
    onSortChange(selectedOption, sortAsc); // 调用父组件传入的排序回调函数
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value); // 更新选中的排序选项
    onSortChange(event.target.value, sortAsc); // 调用父组件传入的排序回调函数
  };

  const handleFilterIconClick = () => {
    setShowFilterModal(true); // 点击FilterIcon时显示FilterModal
  };

  const handleModalClose = () => {
    setShowFilterModal(false); // 关闭FilterModal
  };

  return (
    <div className="filter-sort-bar">
      <FilterIcon className="filter-icon" onClick={handleFilterIconClick} />
      <div className="sort-icon-container" onClick={handleSortClick}>
        {sortAsc ? <SortIcon1 className="sort-icon" /> : <SortIcon2 className="sort-icon" />}
      </div>
      <select value={selectedOption} onChange={handleOptionChange} className="filter-dropdown">
        <option value="signal_strength">信号强度</option>
        <option value="snr">SNR</option>
        <option value="ssid">SSID</option>
        <option value="channel_count">信道数量</option>
        <option value="ap_count">AP数量</option>
      </select>
      {/* {showFilterModal && <FilterModal onClose={handleModalClose} />} 根据状态决定是否显示FilterModal */}
    </div>
  );
};

export default FilterSortBar;
